export default "__VITE_ASSET__d5a72d96__"